/**
 * Capture stages — ARCHITECTURE.md §1 (Final Capture Contract), §21 (Upload Architecture).
 */
export const CAPTURE_STAGES = ['licence_front', 'licence_back', 'selfie_liveness'];
/** Upload initiation must follow this order — §21. */
export const STAGE_ORDER = CAPTURE_STAGES;
export const STAGE_SPECS = {
    licence_front: {
        stage: 'licence_front',
        camera: 'rear_wide',
        focusTarget: 'card_inner_surface',
        nominalDurationMs: 10_000,
        acceptedDurationMs: { min: 9_800, max: 10_800 },
    },
    licence_back: {
        stage: 'licence_back',
        camera: 'rear_wide',
        focusTarget: 'barcode_or_card_centre',
        nominalDurationMs: 10_000,
        acceptedDurationMs: { min: 9_800, max: 10_800 },
    },
    selfie_liveness: {
        stage: 'selfie_liveness',
        camera: 'front',
        focusTarget: 'face_eyes',
        nominalDurationMs: 20_000,
        acceptedDurationMs: { min: 18_000, max: 24_800 },
    },
};
/** §19 — outputs per accepted stage video. */
export const STAGE_OUTPUT_BASENAMES = {
    licence_front: { original: 'licence-front-original', bestFrame: 'licence-front-best-video-frame.jpg' },
    licence_back: { original: 'licence-back-original', bestFrame: 'licence-back-best-video-frame.jpg' },
    selfie_liveness: { original: 'selfie-liveness-original', bestFrame: 'selfie-best-frontal-frame.jpg' },
};
//# sourceMappingURL=stages.js.map